module.exports = __webpack_public_path__ + "img/img_engineering_phone_img3.59477928.png";